import qs from "qs";
import axios from "axios";

export default function (config) {
    const instance = axios.create({
        baseURL: window.location.href.includes("localhost")
            ? "https://mock.apipost.net/mock/2d3e84"
            : "https://actxyx.web.sdo.com",
        timeout: 5000
    });
    instance.interceptors.request.use(
        (config) => {
            // POST处理
            if (config.method.toLowerCase() == "post") {
                // 上传图片单独配置headers
                if (config.isPicUpload) {
                    config.headers = { "Content-Type": "multipart/form-data" };
                } else {
                    config.data = qs.stringify(config.data);
                }
            }
            return config;
        },
        (err) => {
            CsGame.alert("网络不好，请稍后重试！", 500, "error");
        }
    );
    instance.interceptors.response.use(
        (res) => {
            // 接口success处理
            if (res.data.hasOwnProperty("success")) {
                if (res.data.success) {
                    return res.data.msg;
                } else {
                    return CsGame.alert(res.data.msg, 1200, "error");
                }
            }
            // 接口code处理
            if (res.data.hasOwnProperty("code")) {
                if (res.data.code == 0) {
                    return res.data.msg;
                } else {
                    if (res.data.code == "-992") {
                        return CsGame.alert("通行证未登录", 1200, "error");
                    } else {
                        return CsGame.alert(res.data.msg, 1200, "error");
                    }
                }
            }
        },
        (err) => {
            CsGame.alert("网络不好，请稍后重试！", 500, "error");
        }
    );
    return instance(config);
}
